import React from "react";
import "../styles/Gallery.css";

function Gallery({ images, headerText, paragraphText }) {
  return (
	<div className="gallery-container">
	  {(headerText || paragraphText) && (
		<div className="gallery-header">
		  {headerText && <h2>{headerText}</h2>}
		  {paragraphText && <p className="gallery-description">{paragraphText}</p>}
		</div>
	  )}

	  <div className="gallery-scroll">
		{images.map((image, index) => (
		  <div key={index} className="gallery-item">
			<img src={image} alt={`Gallery item ${index + 1}`} />
		  </div>
		))}
	  </div>

	  <div className="gallery-dots">
		{images.map((_, index) => (
		  <span className="dot" key={index}></span>
		))}
	  </div>
	</div>
  );
}

export default Gallery;